import {Injectable} from '@angular/core';
import {HttpErrorResponse} from "@angular/common/http";
import {AuthService} from "../../modules/common/modules/auth/services/auth.service";
import {NotifierService} from "./notifier/notifier.service";
import {CommonBase} from "../common/base.common";
import {IAuth} from "../../modules/common/modules/auth/models/auth.model";

@Injectable({
  providedIn: 'root'
})
export class BaseService extends CommonBase {

  maxRetry = 10
  retryCount = 0

  constructor(
    protected authService: AuthService,
    protected notifier: NotifierService
  ) {
    super();
  }

  handleError(
    err: HttpErrorResponse,
    onTokenRefreshed: (auth: IAuth) => void,
    other: (err: HttpErrorResponse) => void
  ) {
    // Token refresh/re-auth is handled globally by TokenRefreshInterceptor.
    // Always forward the error to component-level handlers.
    other(err);
  }

}
